import Dexie from "dexie";
import { IDatabaseUpgrade } from "../database-upgrade";

/**
 * Defines the upgrade path for version 10 of indexed DB.
 */
export class DatabaseUpgradeV10 implements IDatabaseUpgrade {
	/** @inheritdoc */
	public readonly Version: number = 10;

	/** @inheritdoc */
	public Upgrade(dexieInstance: Dexie): void {
		dexieInstance.version(this.Version).stores({
			DispatchedServiceSyncData: "Id, UserName, CrownId, LegacyId, SyncType"
		});
	}
}